import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, Directive, Input } from '@angular/core';
import { ownedError } from 'core/utils/owned-error';

export type LayoutPreset = 'data' | 'form' | 'compact';

const PRESET_MAX_WIDTH: Record<Exclude<LayoutPreset, 'data'>, string> = {
  form: '40rem',
  compact: '24rem',
};

@Directive({
  selector: 'app-layout-title',
  standalone: false,
})
export class LayoutHeaderDirective {
  @Input() align: 'start' | 'end' | 'center' = 'start';
}

@Directive({
  selector: 'app-layout-actions',
  standalone: false,
})
export class LayoutActionsDirective {
  @Input() align: 'start' | 'end' | 'center' = 'center';
}

@Directive({
  selector: 'app-layout-content',
  standalone: false,
})
export class LayoutContentDirective {
}

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LayoutComponent implements AfterContentInit {
  @Input() hAlignment: 'start' | 'end' | 'center' = 'center';
  @Input() vAlignment: 'top' | 'middle' | 'bottom' | 'around' | 'between' = 'top';

  @Input() columnCount = 6;
  @Input() maxWidth: string | null = null;
  @Input() preset: LayoutPreset | null = null;

  @ContentChild(LayoutHeaderDirective)
  title?: LayoutHeaderDirective;

  @ContentChild(LayoutActionsDirective)
  actions?: LayoutActionsDirective;

  @ContentChild(LayoutContentDirective)
  content?: LayoutContentDirective;

  get panelWidth(): string {
    return this.preset ? '100%' : `${this.columnCount / 12 * 100}%`;
  }

  get panelMaxWidth(): string | null {
    if (this.maxWidth !== null || !this.preset || this.preset === 'data') {
      return this.maxWidth;
    }

    return PRESET_MAX_WIDTH[this.preset];
  }

  ngAfterContentInit(): void {
    if (!this.content) {
      throw ownedError(new Error('Content not defined'));
    }
  }
}
